import type { fr } from './fr.js';

/** Dictionnaire ukrainien. Doit couvrir toutes les clés du français (vérifié par le type). */
export const uk: Record<keyof typeof fr, string> = {
  'common.loading': 'Завантаження…',
  'common.error': 'Помилка',

  'nav.open': 'Відкрити навігацію',
  'nav.close': 'Закрити навігацію',
  'nav.expandSection': 'Розгорнути розділ',
  'nav.collapseSection': 'Згорнути розділ',

  'search.label': 'Пошук',
  'search.placeholder': 'Шукати проєкти, відео, моделі…',
  'search.clear': 'Очистити пошук',
  'search.searching': 'Пошук…',
  'search.empty': 'Нічого не знайдено.',
  'search.group.videos': 'Відео',
  'search.group.projects': 'Проєкти',
  'search.group.missions': 'Польотні сесії',
  'search.group.models': 'Моделі',
  'search.group.libraryModels': 'Бібліотека моделей',

  'assistant.title': 'ШІ-асистент',
  'assistant.close': 'Закрити асистента',
  'assistant.intro': 'Поставте запитання про ваші проєкти, відео чи моделі.',
  'assistant.placeholder': 'Ваше запитання…',
  'assistant.disabledPlaceholder': 'Асистент недоступний',
  'assistant.inputLabel': 'Запитання до асистента',
  'assistant.send': 'Надіслати',
  'assistant.thinking': 'Асистент думає…',
  'assistant.attach': 'Прикріпити відео',
  'assistant.attaching': 'Завантаження…',
  'assistant.attachRemove': 'Прибрати вкладення',
  'assistant.dropHint': 'Перетягніть відео, щоб прикріпити',
  'assistant.adopt': 'Прийняти',
  'assistant.adopting': 'Прийняття…',
  'assistant.adopted': 'Прийнято',
  'assistant.adoptFailed': 'Помилка прийняття',
  'assistant.adoptNeedsEditor': 'Потрібна роль редактора для прийняття.',
  'assistant.soonTitle': 'Незабаром',
  'assistant.soonBody':
    'Асистент стане доступним після налаштування ключа API на сервері (ADR-0016).',

  'account.assistant': 'ШІ-асистент',
  'account.notifications': 'Сповіщення (незабаром)',
  'account.profile': 'Профіль',
  'account.settings': 'Налаштування',
  'account.logout': 'Вийти',
  'account.themeToLight': 'Перемкнути на денну тему',
  'account.themeToDark': 'Перемкнути на нічну тему',
  'language.label': 'Мова',
  'language.french': 'Французька',
  'language.english': 'Англійська',
  'language.ukrainian': 'Українська',

  'overview.title': 'Overview',
  'overview.intro': 'Огляд вашої організації та доступ до чотирьох основних функцій.',
  'overview.tile.projects': 'Проєкти',
  'overview.tile.campaigns': 'Кампанії',
  'overview.projects.title': 'Проєкти',
  'overview.projects.new': 'Новий проєкт',
  'overview.projects.manage': 'Керувати в Data →',
  'overview.projects.empty': 'Ще немає проєктів. Згрупуйте відео, зображення та моделі в проєкт.',
  'overview.projects.videos': 'відео',
  'overview.projects.rename': 'Перейменувати',
  'overview.projects.delete': 'Видалити',
  'overview.projects.deleteTitle': 'Видалити проєкт',
  'overview.projects.deleteBody':
    'Проєкт видаляється, але пов’язані відео, зображення та моделі залишаються.',
  'overview.projects.formName': 'Назва проєкту',
  'overview.projects.formDesc': 'Опис (необов’язково)',
  'overview.projects.namePlaceholder': 'напр. Дрон-переслідувач',
  'overview.projects.save': 'Зберегти',
  'overview.projects.cancel': 'Скасувати',
  'overview.tile.sessions': 'Польотні сесії',
  'overview.tile.videos': 'Відео',
  'overview.tile.images': 'Зображення',
  'overview.tile.models': 'Моделі',
  'overview.recentVideos': 'Останні відео',
  'overview.evaluatedModels': 'Оцінені моделі',
  'overview.noVideos': 'Ще немає відео.',
  'overview.noVideosCta': 'Додайте їх у розділі Data collection.',
  'overview.noEval': 'Ще немає оцінок.',
  'overview.noEvalCta': 'Оцініть модель у розділі Model.',
  'overview.seeAll': 'Переглянути все',
  'overview.compare': 'Порівняти',

  'overview.guide.lead.new': 'Ваш ланцюг — від поля до обладнання.',
  'overview.guide.lead.active': 'Продовжте з того місця, де зупинились, або почніть нову дію.',
  'overview.guide.workflow.title': 'Створити повний робочий процес',
  'overview.guide.workflow.desc':
    'Об’єднайте чотири кроки в керований шлях — від даних до розгортання.',
  'overview.guide.workflow.cta': 'Почати',
  'overview.guide.step.data': 'Дані',
  'overview.guide.step.data.desc': 'Відео, симуляція',
  'overview.guide.step.annotation': 'Анотація',
  'overview.guide.step.annotation.desc': 'Розмітити, попередньо анотувати',
  'overview.guide.step.model': 'Модель',
  'overview.guide.step.model.desc': 'Імпортувати, адаптувати, оцінити',
  'overview.guide.step.deploy': 'Розгортання',
  'overview.guide.step.deploy.desc': 'Спакувати для цілі',
  'overview.guide.state.todo': 'Зробити',
  'overview.guide.state.soon': 'Незабаром',
  'overview.guide.cmd.data': 'Додати дані',
  'overview.guide.cmd.model': 'Створити / оновити модель',
  'overview.guide.cmd.deploy': 'Розгорнути',
  'overview.guide.resume.label': 'Продовжити',
  'overview.guide.resume.toAnnotate': 'для анотації',
  'overview.guide.resume.open': 'відкрити',

  'workflow.title': 'Керований маршрут',
  'workflow.intro':
    'Від даних до розгорнутої моделі, крок за кроком. Ваш поступ зчитується з ваших даних — нічого не треба позначати вручну.',
  'workflow.progress': 'кроків завершено',
  'workflow.revisit': 'Переглянути знову',
  'workflow.state.done': 'Готово',
  'workflow.state.current': 'Зробіть зараз',
  'workflow.state.todo': 'Попереду',
  'workflow.state.locked': 'Незабаром',
  'workflow.count.videos': 'відео',
  'workflow.count.annotated': 'анотованих',
  'workflow.count.models': 'моделей',
  'workflow.count.evaluated': 'оцінених',
  'workflow.allDone.title': 'Маршрут завершено',
  'workflow.allDone.desc':
    'Ваші дані пройшли весь доступний ланцюг. Розгортання на обладнання з’явиться незабаром.',
  'workflow.step.data.title': 'Додати дані',
  'workflow.step.data.body':
    'Завантажте свої відео з дрона та їхню телеметрію. Вони транскодуються й готові до анотації.',
  'workflow.step.data.action': 'Додати дані',
  'workflow.step.annotation.title': 'Анотувати',
  'workflow.step.annotation.body':
    'Позначте об’єкти інтересу рамками або дозвольте попередній анотації випередити вас.',
  'workflow.step.annotation.action': 'Анотувати відео',
  'workflow.step.model.title': 'Отримати модель',
  'workflow.step.model.body':
    'Імпортуйте модель .onnx або адаптуйте одну з бібліотеки — готову до оцінювання на ваших даних.',
  'workflow.step.model.action': 'Створити або адаптувати модель',
  'workflow.step.evaluation.title': 'Оцінити',
  'workflow.step.evaluation.body':
    'Виміряйте модель на ваших анотованих відео (mAP, влучність, повнота), щоб дізнатися її справжню цінність.',
  'workflow.step.evaluation.action': 'Оцінити модель',
  'workflow.step.deploy.title': 'Розгорнути на обладнанні',
  'workflow.step.deploy.body':
    'Спакуйте перевірену модель для цільового середовища (ONNX, TFLite, TensorRT). Незабаром.',
  'workflow.step.deploy.action': 'Розгорнути',

  'deploy.title': 'Deploy',
  'deploy.intro':
    'Розгорніть перевірену модель на обраному обладнанні (дрон, UGV…) та адаптуйте її до його обмежень.',
  'deploy.soonBadge': 'Незабаром (ADR-0014, Phase D).',
  'deploy.soonLead':
    'Цей розділ дозволить упакувати модель у формат цільового середовища виконання (ONNX, TFLite, TensorRT), за потреби квантувати її та розгорнути на пристрої, обраному зі списку.',
  'deploy.families': 'Дві родини характеристик, розділені за задумом:',
  'deploy.computeLabel': 'Обчислення та сенсор',
  'deploy.computeText':
    'SoC/прискорювач, затримка, потужність, роздільність/поле зору камери. Саме це справді адаптує модель: вибір її розміру та квантування, щоб вкластися у бортовий бюджет.',
  'deploy.airframeLabel': 'Airframe',
  'deploy.airframeText':
    'вага, динаміка польоту, двигуни. Зберігається як метадані флоту (інвентаризація, автономність, планування); ці величини не параметризують модель бачення.',

  'model.error.load': 'Не вдалося завантажити',
  'model.error.historyUnavailable': 'Історія недоступна',
  'model.error.evaluate': 'Не вдалося оцінити',
  'model.error.required': 'Потрібні назва, версія та файл .onnx.',
  'model.error.tooLarge': 'Файл завеликий (максимум 2 ГБ).',
  'model.error.uploadRefused': 'Сховище відхилило завантаження артефакту',
  'model.error.import': 'Не вдалося імпортувати',
  'model.error.delete': 'Не вдалося видалити',
  'model.loading': 'Завантаження…',
  'model.title': 'Моделі',
  'model.intro':
    'Імпортуйте свої моделі виявлення (ONNX), щоб оцінювати їх на анотованих даних, а згодом навчати та розгортати на вашому обладнанні (ADR-0014).',
  'model.notif.errorTitle': 'Помилка',
  'model.notif.actionErrorTitle': 'Не вдалося виконати дію',
  'model.import.title': 'Створити модель',
  'model.field.name': 'Назва',
  'model.field.namePlaceholder': 'напр. yolov8n',
  'model.field.version': 'Версія',
  'model.field.versionPlaceholder': 'напр. 1',
  'model.field.inputSize': 'Розмір входу',
  'model.field.classes': 'Класи (по одному на рядок, у порядку індексів моделі)',
  'model.field.classesHelper': 'Порожнє = стандартні класи COCO типової моделі YOLO.',
  'model.field.description': 'Опис (необов’язково)',
  'model.field.artifact': 'Артефакт .onnx',
  'model.import.busy': 'Імпорт…',
  'model.import.submit': 'Імпортувати модель',
  'model.compare.title': 'Порівняння',
  'model.compare.evaluatedSuffix': 'оцінено',
  'model.compare.col.model': 'Модель',
  'model.compare.col.precision': 'Точність',
  'model.compare.col.recall': 'Повнота',
  'model.compare.col.images': 'Зображення',
  'model.compare.hint':
    'Відсортовано за спаданням mAP. Порівняння коректне лише якщо моделі оцінювалися на одному наборі — перевірте відео в історії кожної.',
  'model.registry.title': 'Реєстр',
  'model.zoo.mine': 'Ваші моделі',
  'model.zoo.catalog': 'Каталог попередньо навчених',
  'model.zoo.catalogHint': 'Уже навчені моделі (Yolo, ResNet…), готові до впровадження.',
  'model.registry.empty': 'Поки що немає зареєстрованих моделей.',
  'model.status.ready': 'Готово',
  'model.status.pending': 'Очікує',
  'model.status.failed': 'Помилка',
  'model.classesCountSuffix': 'клас(и)',
  'model.source.trained': 'навчено',
  'model.source.imported': 'імпортовано',
  'model.byPrefix': 'від',
  'model.action.evaluate': 'Оцінити',
  'model.action.hide': 'Сховати',
  'model.action.history': 'Історія',
  'model.action.delete': 'Видалити',
  'model.eval.headingPrefix': 'Оцінити',
  'model.eval.busy': 'Запуск…',
  'model.eval.submit': 'Запустити оцінювання',
  'model.eval.cancel': 'Скасувати',
  'model.eval.intro':
    'Оцінювання порівнює прогнози моделі з підтвердженими анотаціями відео на воркері. Метрики (mAP, точність, повнота) з’являться на моделі після завершення прогону.',
  'model.eval.videoLabel': 'Відео (набір для валідації)',
  'model.history.loading': 'Завантаження історії…',
  'model.history.empty': 'Немає оцінювань для цієї моделі.',
  'model.history.status.pending': 'очікує',
  'model.history.status.running': 'виконується',
  'model.history.status.done': 'завершено',
  'model.history.status.failed': 'помилка',
  'model.history.videoFallback': 'відео',
  'model.history.col.class': 'Клас',
  'model.history.col.gt': 'GT',
  'model.history.col.confusion': 'TP/FP/FN',

  // Section navigation for the Model page (ADR-0017).
  'model.section.modelZoo': 'Model Zoo',
  'model.section.build': 'Створити модель',
  'model.section.objectives': 'Цілі',
  'model.objectives.hint':
    'Кожен проєкт і його ціль — поступ зчитується з ваших даних. Відкрийте проєкт, щоб задати або змінити ціль.',
  'model.objectives.empty':
    'Поки немає проєктів. Створіть проєкт в огляді, а потім задайте його ціль.',
  'model.objectives.none': 'Немає цілі — відкрийте проєкт, щоб її задати.',
  'model.objectives.resume': 'Продовжити',
  'model.objectives.completed': 'Завершено',
  'model.objectives.ongoing': 'Поточні цілі',
  'model.section.useCases': 'Сценарії використання',

  // Блок процесу «Створити модель» вгорі сторінки (ADR-0028).
  'model.process.title': 'Створити модель',
  'model.process.intro':
    'Від цілі до розгорнутої моделі — за шість кроків. Усе починається з цілі проєкту: що виявляти, на яких даних і для якого обладнання.',
  'model.process.flowLabel': 'Кроки створення моделі',
  'model.process.step.objective': 'Ціль',
  'model.process.step.data': 'Дані',
  'model.process.step.baseModel': 'Базова модель',
  'model.process.step.train': 'Навчити',
  'model.process.step.evaluate': 'Оцінити',
  'model.process.step.deploy': 'Розгорнути',
  'model.process.cta': 'Розпочати ціль проєкту',
  'model.process.ctaNote': 'Починаємо з кроку 1: визначити ціль проєкту.',

  // Модальне вікно «Розпочати ціль проєкту».
  'model.startObjective.title': 'Розпочати ціль проєкту',
  'model.startObjective.intro':
    'Ціль визначається в межах проєкту. Оберіть наявний проєкт або створіть новий — далі ви визначите, що має виявляти модель.',
  'model.startObjective.projectLegend': 'Проєкт',
  'model.startObjective.modeExisting': 'Наявний проєкт',
  'model.startObjective.modeNew': 'Новий проєкт',
  'model.startObjective.pickProject': 'Проєкт',
  'model.startObjective.newName': 'Назва проєкту',
  'model.startObjective.confirm': 'Продовжити',
  'model.startObjective.noRightTitle': 'Немає доступного проєкту',
  'model.startObjective.noRightBody':
    'Проєктів ще немає, а ваша роль не дозволяє їх створювати. Попросіть редактора організації створити проєкт.',
  'model.startObjective.useCasesTitle': 'Сценарії використання — щоб окреслити ціль',
  'model.startObjective.useCasesHint':
    'Поширені операційні ситуації для натхнення перед визначенням цілі.',

  // "Your models" section — empty state.
  'model.yours.empty.title': 'Поки що немає моделей',
  'model.yours.empty.body':
    'Імпортуйте модель виявлення (ONNX), щоб оцінити її на ваших анотованих даних.',
  'model.yours.empty.cta': 'Створити модель',

  // "Use cases" section.
  'model.useCases.intro':
    'Операційні ситуації, які потребують моделі. Почніть з каталогу або додайте власні.',
  'model.useCases.dataLabel': 'Дані',
  'model.useCases.add': 'Запропонувати сценарій використання',
  'model.useCases.addSoon':
    'Незабаром: додавайте власні сценарії використання після перевірки, що вони ще не існують.',
  'model.useCase.fpv.name': 'Виявлення FPV',
  'model.useCase.fpv.desc':
    'Виявлення FPV-дронів (імерсивне пілотування), часто швидких і невеликих.',
  'model.useCase.shahed.name': 'Виявлення Shahed',
  'model.useCase.shahed.desc':
    'Дистанційне розпізнавання дронів типу Shahed-136 (баражуючі боєприпаси).',
  'model.useCase.lightVehicle.name': 'Виявлення легкого транспорту',
  'model.useCase.lightVehicle.desc': 'Виявлення легкових автомобілів, пікапів і фургонів з висоти.',
  'model.useCase.objectTracking.name': 'Відстеження об’єкта',
  'model.useCase.objectTracking.desc': 'Супровід цілі кадр за кадром після виявлення.',
  'model.useCase.terrain.name': 'Розвідка місцевості',
  'model.useCase.terrain.desc':
    'Характеристика поверхні: рослинність, забудова, комунікації, точки проходу.',
  'model.useCase.personnel.name': 'Виявлення особового складу',
  'model.useCase.personnel.desc': 'Виявлення людей на відкритій місцевості, вдень і вночі (IR).',

  // "Models" section — pre-trained library.
  'model.lib.intro':
    'Бібліотека попередньо навчених моделей для завантаження з HuggingFace. Впорядковані за типом даних, розміром і виявленими об’єктами.',
  'model.lib.filter.all': 'Усі',
  'model.lib.objectsLabel': 'Об’єкти',
  'model.lib.view': 'Переглянути на HuggingFace',
  'model.lib.searchHint':
    'Робіть запити до цієї бібліотеки з рядка пошуку або асистента (незабаром).',
  'model.lib.empty': 'Немає моделей для цього типу даних.',
  'model.dataType.optical': 'Оптичний',
  'model.dataType.ir': 'IR',
  'model.dataType.acoustic': 'Акустичний',
  'model.dataType.radar': 'Радар',
  'model.lib.objects.coco': '80 класів COCO (люди, транспорт, тварини…)',
  'model.lib.objects.aerial':
    'Об’єкти з висоти: пішоходи, автомобілі, вантажівки, автобуси, велосипеди.',
  'model.lib.objects.thermalPerson': 'Люди та транспорт на тепловізійних зображеннях.',
  'model.lib.objects.flir': 'Пішоходи, транспорт і двоколісні (тепловізор, ADAS).',
  'model.lib.objects.acousticDrone': 'Акустична сигнатура дрона (наявність/відсутність).',
  'model.lib.objects.sarVehicle':
    'Транспорт на радарних зображеннях із синтезованою апертурою (SAR).',
  'model.lib.objects.microDoppler': 'Дрони проти птахів за сигнатурою micro-Doppler.',

  'model.lib.loadError': 'Не вдалося завантажити бібліотеку.',
  'model.lib.liveOff': 'Збагачення в реальному часі вимкнено — курований каталог.',
  'model.lib.detectsLabel': 'Виявляє',
  'model.lib.reliability.high': 'Висока надійність',
  'model.lib.reliability.medium': 'Середня надійність',
  'model.lib.reliability.low': 'Низька надійність',
  'model.lib.reliability.unevaluated': 'Потребує оцінки',
  'model.lib.reliabilityHint.measured': 'Надійність виміряна на ваших анотованих даних.',
  'model.lib.reliabilityHint.unevaluated': 'Ще не оцінено на ваших даних — запустіть оцінку.',
  'model.lib.field.data': 'Дані',
  'model.lib.field.form': 'Форм-фактор',
  'model.lib.field.speed': 'Швидкість',
  'model.lib.field.ready': 'Готово до використання',
  'model.lib.form.embedded': 'Легка, вбудовувана',
  'model.lib.form.ground': 'Наземна станція',
  'model.lib.speed.realtime': 'Реальний час',
  'model.lib.speed.batch': 'Пакетна обробка',
  'model.lib.ready.yes': 'ONNX доступний',
  'model.lib.ready.no': 'Потрібна конвертація',
  'model.lib.rightsLabel': 'Права',
  'model.lib.rights.commercialYes': 'Комерційне використання',
  'model.lib.rights.commercialEnterprise': 'Комерційне використання — потрібна ліцензія Enterprise',
  'model.lib.rights.commercialNo': 'Комерційне використання заборонено',
  'model.lib.rights.militaryYes': 'Військове використання дозволено',
  'model.lib.rights.militaryNo': 'Військове використання обмежено',
  'model.lib.rights.copyleft': 'Потрібно робити внесок у відкритий код (AGPL)',
  'model.lib.rights.attribution': 'Потрібне зазначення авторства',
  'model.lib.rights.none': 'Немає зобов’язань щодо відкритого коду',
  'model.lib.tech.title': 'Технічні деталі',
  'model.lib.tech.params': 'Параметри',
  'model.lib.tech.license': 'Ліцензія',
  'model.lib.tech.downloads': 'Завантаження',
  'model.lib.tech.updated': 'Оновлено',
  'model.lib.tech.reported': 'Заявлена ліцензія',
  'model.lib.tech.source': 'Джерело',

  'data.status.pending': 'Очікує',
  'data.status.uploading': 'Завантаження',
  'data.status.uploaded': 'Завантажено',
  'data.status.processing': 'Обробка',
  'data.status.ready': 'Готово',
  'data.status.failed': 'Помилка',
  'data.title': 'Data',
  'data.subtitle': 'Ваші відео, зображення та симуляції — збір і підготовка даних.',
  'data.section.videos': 'Відео',
  'data.section.images': 'Зображення',
  'data.section.simulations': 'Симуляції',
  'data.more.videos': 'Інші відео',
  'data.more.images': 'Інші зображення',
  'data.more.hint': 'Показати все',
  'data.videosPage.subtitle': 'Усі відео вашої організації.',
  'data.imagesPage.subtitle': 'Усі зображення, отримані у вашій організації.',
  'data.upload.dropLabel':
    'Перетягніть відео сюди або натисніть, щоб вибрати — MP4, MOV, MKV (макс. 20 ГБ)',
  'data.upload.finalizing': 'Завершення…',
  'data.upload.uploading': 'Завантаження',
  'data.action.cancel': 'Скасувати',
  'data.upload.errorTitle': 'Помилка завантаження',
  'data.load.errorTitle': 'Не вдалося завантажити',
  'data.empty': 'Поки що немає відео.',
  'data.emptyInSession': 'У цій льотній сесії немає відео.',
  'data.meta.file': 'Файл',
  'data.meta.size': 'Розмір',
  'data.meta.added': 'Додано',
  'data.meta.asset': 'Апарат',
  'data.action.moveToSession': 'Перемістити до сесії',
  'data.action.addToProject': 'Додати до проєкту',
  'data.addToProject.heading': 'Додати до проєкту',
  'data.addToProject.empty': 'Ще немає проєктів — створіть його в огляді (Overview).',
  'data.addToProject.add': 'Додати',
  'data.addToProject.added': 'Додано',
  'project.notFound.title': 'Проєкт не знайдено',
  'project.notFound.body': 'Цей проєкт не існує або не належить вашій організації.',
  'project.empty':
    'Цей проєкт порожній — додайте відео, зображення або моделі зі сторінок «Data» та «Model».',
  'project.videos.empty': 'У цьому проєкті немає відео — додайте їх зі сторінки «Data».',
  'project.videos.addedOn': 'Додано',
  'project.videos.remove': 'Вилучити з проєкту',
  'project.item.remove': 'Вилучити з проєкту',
  'project.images.of': 'Зображення з',

  // Ціль проєкту та керований план (ADR-0028).
  'objective.title': 'Ціль',
  'objective.empty': 'Ціль ще не задано. Скажіть, що ви хочете створити — платформа побудує план.',
  'objective.define': 'Задати ціль',
  'objective.edit': 'Змінити',
  'objective.remove': 'Прибрати',
  'objective.plan.title': 'Керований план дій',
  'objective.form.task': 'Завдання',
  'objective.form.targets': 'Цілі для виявлення',
  'objective.form.targetsHint': 'Цільові класи, через кому.',
  'objective.form.targetsPlaceholder': 'напр. Shahed-136, FPV, легкий автомобіль',
  'objective.form.modality': 'Тип даних',
  'objective.form.support': 'Носій',
  'objective.form.deployTarget': 'Ціль розгортання',
  'objective.form.dataOnHand': 'Наявні дані',
  'objective.task.DETECTION': 'Виявлення',
  'objective.task.TRACKING': 'Стеження',
  'objective.task.TERRAIN': 'Розпізнавання місцевості',
  'objective.task.TRAJECTORY': 'Прогноз траєкторії',
  'objective.task.soon': 'незабаром',
  'objective.modality.OPTICAL': 'Оптика',
  'objective.modality.INFRARED': 'Інфрачервоне',
  'objective.modality.ACOUSTIC': 'Акустика',
  'objective.modality.RADAR': 'Радар',
  'objective.modality.TELEMETRY': 'Телеметрія',
  'objective.support.IMAGE': 'Нерухоме зображення',
  'objective.support.VIDEO_STREAM': 'Відеопотік',
  'objective.support.TIME_SERIES': 'Часовий ряд',
  'objective.deploy.DRONE': 'Бортовий (дрон)',
  'objective.deploy.UGV': 'Бортовий (UGV)',
  'objective.deploy.GROUND': 'Наземний',
  'objective.dataOnHand.NONE': 'Поки нічого',
  'objective.dataOnHand.VIDEOS': 'Є відео',
  'objective.dataOnHand.LOGS': 'Журнали польотів',
  'objective.step.dataset': 'Зібрати анотований набір',
  'objective.step.datasetUnit': 'анотованих зображень',
  'objective.step.baseModel': 'Обрати базову модель',
  'objective.step.train': 'Навчити / до-навчити',
  'objective.step.evaluate': 'Оцінити',
  'objective.step.deploy': 'Розгорнути на обладнанні',
  'objective.step.analyze': 'Аналізувати та покращувати',
  'objective.step.comingSoon': 'Незабаром',
  'objective.branch.annotate': 'Анотувати зображення',
  'objective.branch.reuse': 'Повторно використати анотовані дані',
  'objective.branch.clean': 'Очистити набір даних',
  'objective.branch.simulate': 'Згенерувати синтетичні дані',
  'objective.branch.field': 'Спланувати польове збирання',
  'objective.branch.adopt': 'Адаптувати з бібліотеки',
  'objective.branch.import': 'Імпортувати .onnx',
  'objective.branch.recommended': 'рекомендовано',
  'data.action.share': 'Поділитися',
  'data.action.delete': 'Видалити',
  'data.sessions.title': 'Льотні сесії',
  'data.sessions.new': 'Нова сесія',
  'data.filter.all': 'Усі',
  'data.filter.asset': 'Апарат',
  'data.filter.allAssets': 'Усі апарати',
  'data.sessions.edit': 'Редагувати сесію',
  'data.error.saveFailed': 'Не вдалося зберегти.',
  'data.session.editHeading': 'Редагувати льотну сесію',
  'data.session.newHeading': 'Нова льотна сесія',
  'data.action.saving': 'Збереження…',
  'data.action.save': 'Зберегти',
  'data.session.hint': 'Льотна сесія об’єднує відео одного вильоту: одного дня, місця, кампанії.',
  'data.field.name': 'Назва',
  'data.session.namePlaceholder': 'напр. ЛЕП — північний сектор',
  'data.field.campaign': 'Кампанія',
  'data.session.campaignHelper': 'Кампанія (проєкт), що об’єднує цю сесію та її зображення.',
  'data.field.description': 'Опис',
  'data.field.location': 'Місце',
  'data.session.locationPlaceholder': 'напр. Ділянка B12, Обань',
  'data.field.flightDate': 'Дата польоту',
  'data.field.contributors': 'Учасники',
  'data.session.contributorsHelper': 'Через кому',
  'data.session.contributorsPlaceholder': 'напр. Alice Martin, Bob Durand',
  'data.field.asset': 'Апарат',
  'data.session.assetHelper': 'Дрон або наземний апарат флоту, що виконав виліт.',
  'data.session.assetNone': '— Немає —',
  'data.error.title': 'Помилка',
  'data.error.moveFailed': 'Не вдалося перемістити.',
  'data.move.heading': 'Перемістити до сесії',
  'data.move.moving': 'Переміщення…',
  'data.action.move': 'Перемістити',
  'data.move.noSessions': 'Немає доступних льотних сесій. Спершу створіть одну.',
  'data.error.deleteFailed': 'Не вдалося видалити.',
  'data.delete.heading': 'Видалити відео',
  'data.delete.deleting': 'Видалення…',
  'data.delete.confirmPrefix': 'Відео',
  'data.delete.confirmSuffix':
    'та його файли буде видалено. Наявні анотації зберігаються для відстежуваності. Цю дію не можна скасувати.',
  'data.error.shareCreateFailed': 'Не вдалося створити посилання.',
  'data.share.heading': 'Поділитися відео',
  'data.share.done': 'Готово',
  'data.share.creating': 'Створення…',
  'data.share.create': 'Створити посилання',
  'data.share.introPrefix': 'Публічне посилання надасть доступ до',
  'data.share.introSuffix': 'без потреби в обліковому записі.',
  'data.share.expiryLabel': 'Термін дії (днів)',
  'data.share.includeAnnotations': 'Включити анотації',
  'data.share.allowDownload': 'Дозволити завантаження джерела',
  'data.share.created': 'Посилання створено. Скопіюйте його: токен показується лише один раз.',
  'data.share.linkLabel': 'Посилання для доступу',
  'data.action.copied': 'Скопійовано',
  'data.action.copy': 'Копіювати',
  'data.share.validUntil': 'Дійсне до',
  'data.error.exportFailed': 'Не вдалося експортувати.',
  'data.images.title': 'Зображення',
  'data.images.hint':
    'Натисніть на зображення, щоб вибрати його, — або утримуйте та наводьте, щоб вибрати кілька, — потім експортуйте набір у форматі YOLO (.zip).',
  'data.images.toolbarAria': 'Дії з вибраними зображеннями',
  'data.images.selectedCount': 'вибрано',
  'data.images.noSelection': 'Нічого не вибрано',
  'data.images.selectAll': 'Вибрати все',
  'data.images.deselectAll': 'Зняти вибір',
  'data.images.preparing': 'Підготовка…',
  'data.images.download': 'Завантажити',
  'data.images.inYolo': 'у форматі YOLO',
  'data.images.exportErrorTitle': 'Помилка експорту',
  'data.images.selectImageOf': 'Вибрати зображення з',
  'data.projects.title': 'Кампанії',
  'data.projects.new': 'Нова кампанія',
  'data.projects.edit': 'Редагувати кампанію',
  'data.project.editHeading': 'Редагувати кампанію',
  'data.project.newHeading': 'Нова кампанія',
  'data.project.hint':
    'Кампанія (проєкт) об’єднує льотні сесії та їхні зображення — напр. «Інспекція мережі ЛЕП 2026».',
  'data.project.namePlaceholder': 'напр. Інспекція мережі ЛЕП 2026',

  'sim.title': 'Симуляція',
  'sim.lead':
    'Створюйте синтетичні навчальні дані, підібрані під ситуацію, коли реальних даних бракує для донавчання моделі.',
  'sim.dormantNote':
    'Фотореалістичний рендер — це опція за згодою: написання сценарію відкрите, запуск активується з GPU-вузлом.',
  'sim.launchDormantTitle': 'Рендер недоступний',
  'sim.launchDormantBody':
    'Сценарій збережено. Рендер почнеться, щойно буде увімкнено GPU-вузол (суверенітет за згодою).',
  'sim.startWith': 'Почати з',
  'sim.describeToAssistant': 'Описати асистенту',
  'sim.field.name': 'Назва партії',
  'sim.field.namePlaceholder': 'напр. Пошук у полі — хмарний ранок',
  'sim.field.environment': 'Середовище',
  'sim.field.timeOfDay': 'Час доби',
  'sim.field.sky': 'Небо',
  'sim.field.altitude': 'Висота (м)',
  'sim.field.gimbal': 'Нахил підвісу (°)',
  'sim.field.imageCount': 'Кількість зображень',
  'sim.field.targets': 'Цілі для виявлення',
  'sim.field.threats': 'Повітряні загрози',
  'sim.field.outputs': 'Виходи',
  'sim.noThreat': 'Немає загроз — додайте з пресету або вручну.',
  'sim.threatPreset.fpvKamikaze': 'FPV-камікадзе 10″',
  'sim.threatPreset.swarm': 'Рій ×10',
  'sim.threatPreset.fixedWing': 'Літакова схема',
  'sim.threatPreset.blank': 'Порожня загроза',
  'sim.threat.remove': 'Прибрати загрозу',
  'sim.threat.type': 'Тип',
  'sim.threat.label': 'Мітка виявлення',
  'sim.threat.labelDefault': '= тип',
  'sim.threat.size': 'Розмір (″)',
  'sim.threat.count': 'Кількість',
  'sim.threat.speedMin': 'Швидкість мін (м/с)',
  'sim.threat.speedMax': 'Швидкість макс (м/с)',
  'sim.threat.approach': 'Захід',
  'sim.threat.trajectory': 'Траєкторія',
  'sim.threat.dispersion': 'Розсіювання (°)',
  'sim.threatType.fpv': 'FPV',
  'sim.threatType.fixedWing': 'Літакова схема',
  'sim.threatType.quad': 'Квадрокоптер',
  'sim.threatType.vtol': 'VTOL',
  'sim.traj.dive': 'Піке',
  'sim.traj.pass': 'Проліт',
  'sim.traj.orbit': 'Орбіта',
  'sim.traj.disperse': 'Розсіювання',
  'sim.traj.hover': 'Завис',
  'sim.approach.frontal': 'Фронтальний',
  'sim.approach.lateral': 'Боковий',
  'sim.approach.vertical': 'Вертикальний',
  'sim.approach.mixed': 'Множинний',
  'sim.field.envSource': 'Джерело середовища',
  'sim.envSource.preset': 'Пресет',
  'sim.envSource.reconstruction': 'Реконструкція — з ваших медіа',
  'sim.field.referenceMedia': 'Медіа зони',
  'sim.media.dormant': '3D-реконструкція · неактивна (GPU)',
  'sim.media.filter': 'Фільтр за назвою…',
  'sim.media.all': 'Усі',
  'sim.media.videos': 'Відео',
  'sim.media.images': 'Зображення',
  'sim.media.empty': 'Немає медіа — додайте через Data → Відео / Зображення.',
  'sim.media.selected': 'медіа обрано',
  'sim.env.field': 'Поле',
  'sim.env.forest': 'Ліс',
  'sim.env.denseHabitat': 'Щільна забудова',
  'sim.env.periurban': 'Приміська зона',
  'sim.time.dawn': 'Світанок',
  'sim.time.day': 'День',
  'sim.time.dusk': 'Сутінки',
  'sim.time.night': 'Ніч',
  'sim.sky.clear': 'Ясно',
  'sim.sky.partlyCloudy': 'Хмарно',
  'sim.sky.overcast': 'Похмуро',
  'sim.sky.fog': 'Туман',
  'sim.output.images': 'Розмічені зображення',
  'sim.output.video': 'Відео',
  'sim.output.imagesShort': 'зображень',
  'sim.output.videoShort': 'відео',
  'sim.removeTarget': 'Прибрати ціль',
  'sim.noTarget': 'Немає цілей — додайте принаймні одну.',
  'sim.addTarget': 'Додати',
  'sim.addTargetPlaceholder': 'Мітка (напр. людина, транспорт)',
  'sim.recap.title': 'Підсумок',
  'sim.recap.previewSoon': 'Попередній перегляд 2.5D — незабаром',
  'sim.recap.previewSchematic': 'Схематичний перегляд 2.5D — не фінальний рендер',
  'sim.recap.previewPhoto': 'Перегляд — репрезентативний фон, не фінальний рендер',
  'sim.backdrop.label': 'Фон (база зображень)',
  'sim.backdrop.none': 'схематичний (не вибрано)',
  'sim.backdrop.choose': 'Вибрати…',
  'sim.backdrop.remove': 'Прибрати',
  'sim.backdrop.modalTitle': 'Виберіть фон для середовища',
  'sim.backdrop.empty': 'У базі ще немає зображень. Витягніть зображення з відео.',
  'sim.backdrop.close': 'Закрити',
  'sim.recap.timeSky': 'Час · небо',
  'sim.recap.altPitch': 'Висота · нахил',
  'sim.create': 'Створити партію',
  'sim.launch': 'Запустити рендер',
  'sim.delete': 'Видалити',
  'sim.batches': 'Партії симуляції',
  'sim.noBatch': 'Ще немає партій симуляції.',
  'sim.synthetic': 'Синтетичне',
  'sim.status.draft': 'Чернетка',
  'sim.status.queued': 'У черзі',
  'sim.status.rendering': 'Рендер…',
  'sim.status.ready': 'На перевірку',
  'sim.status.approved': 'Схвалено',
  'sim.status.rejected': 'Відхилено',
  'sim.status.failed': 'Помилка',
  'sim.cancel': 'Скасувати',
  'sim.review.approve': 'Схвалити',
  'sim.review.reject': 'Відхилити',
  'sim.review.approveError': 'Не вдалося схвалити.',
  'sim.review.rejectError': 'Не вдалося відхилити.',
  'sim.review.approvedBy': 'Схвалив',
  'sim.review.rejectedBy': 'Відхилив',
  'sim.review.rejectHeading': 'Відхилити цей набір?',
  'sim.review.rejecting': 'Відхилення…',
  'sim.review.reasonLabel': 'Причина відхилення',
  'sim.review.reasonPlaceholder':
    'напр. розмитий рендер, неправильне розташування цілей, нереалістичне освітлення…',
  'sim.assistantOff': 'Асистент недоступний: увімкніть його на сервері (ADR-0016).',
  'sim.assistantHint':
    'Опишіть сцену; асистент запропонує сценарій — використовуючи ваші реальні мітки — і заповнить форму. Далі відкоригуйте.',
  'sim.assistError': 'Не вдалося запропонувати сценарій; переформулюйте опис.',
  'sim.assistantPreamble':
    'Запропонуй сценарій симуляції (середовище, час доби, небо, висота, цілі) для цієї потреби:',
  'sim.assistantPlaceholder': 'напр. виявити людей, що впали в полі на світанку',
  'sim.assistantSend': 'Надіслати',
  'sim.template.fieldSearch': 'Пошук у полі',
  'sim.template.forestInspection': 'Інспекція лісу',
  'sim.template.periurbanNight': 'Приміське спостереження',
  'sim.template.counterDrone': 'Протидронний захист',

  // --- Flotte de matériels (ADR-0029) ---
  'fleet.title': 'Парк обладнання',
  'fleet.lead':
    'Дрони, наземні роботи й обчислювачі, на яких навчаються та розгортаються ваші моделі. Кожна картка відокремлює обчислення й сенсори — те, що адаптує модель — від метаданих планера.',
  'fleet.add': 'Додати обладнання',
  'fleet.manage': 'Керувати в Deploy →',
  'fleet.empty': 'У парку поки немає обладнання.',
  'fleet.card.componentsUnit': 'компонентів',
  'fleet.kind.DRONE': 'Дрон',
  'fleet.kind.UGV': 'Наземний робот',
  'fleet.kind.COMPUTE': 'Обчислювач',
  'fleet.kind.SENSOR': 'Сенсор',
  'fleet.kind.OTHER': 'Інше',
  'fleet.status.ACTIVE': 'В експлуатації',
  'fleet.status.BENCH': 'На стенді',
  'fleet.status.MAINTENANCE': 'Обслуговування',
  'fleet.status.STOCK': 'На складі',
  'fleet.family.COMPUTE': 'Обчислення',
  'fleet.family.SENSOR': 'Сенсор',
  'fleet.family.AIRFRAME': 'Планер',
  'fleet.save': 'Зберегти',
  'fleet.cancel': 'Скасувати',
  'fleet.modal.createTitle': 'Додати обладнання',
  'fleet.modal.editTitle': 'Обладнання',
  'fleet.modal.create': 'Створити обладнання',
  'fleet.field.name': 'Назва',
  'fleet.field.nameInvalid': 'Назва обов’язкова.',
  'fleet.field.reference': 'Артикул',
  'fleet.field.kind': 'Тип',
  'fleet.field.status': 'Статус',
  'fleet.field.modality': 'Модальність',
  'fleet.field.unset': '—',
  'fleet.field.family': 'Родина',
  'fleet.field.componentName': 'Компонент',
  'fleet.field.componentDetail': 'Деталь',
  'fleet.field.soc': 'SoC / хост',
  'fleet.field.accelerator': 'Прискорювач',
  'fleet.field.tops': 'Бюджет обчислень',
  'fleet.field.latencyMs': 'Цільова затримка',
  'fleet.field.sensorFeed': 'Потік сенсора',
  'fleet.field.inputResolution': 'Роздільність входу',
  'fleet.field.fovDeg': 'Поле зору',
  'fleet.field.massG': 'Маса',
  'fleet.field.enduranceMin': 'Автономність',
  'fleet.field.propulsion': 'Рушій',
  'fleet.field.maxSpeedMs': 'Макс. швидкість',
  'fleet.field.registration': 'Реєстрація',
  'fleet.field.homeBase': 'База / зберігання',
  'fleet.unit.tops': 'TOPS',
  'fleet.unit.ms': 'мс',
  'fleet.unit.deg': '°',
  'fleet.unit.g': 'г',
  'fleet.unit.min': 'хв',
  'fleet.unit.ms2': 'м/с',
  'fleet.fam.model.badge': 'Адаптує модель',
  'fleet.fam.model.title': 'Обчислення й сенсор',
  'fleet.fam.model.sub':
    'Бюджет обчислень і сенсори, що визначають архітектуру, роздільність входу та формат експорту моделі.',
  'fleet.fam.meta.badge': 'Інвентар',
  'fleet.fam.meta.title': 'Планер і метадані',
  'fleet.fam.meta.sub':
    'Корисно для планування виїздів і обліку парку. Ніколи не є параметром моделі.',
  'fleet.components.title': 'Компоненти',
  'fleet.components.add': 'Додати компонент',
  'fleet.components.remove': 'Вилучити',
  'fleet.wiring.note':
    'З часом це обладнання стане ціллю розгортання цілі, живитиме розгортання й замкне цикл аналізу після розгортання.',
  'fleet.delete.trigger': 'Вилучити це обладнання',
  'fleet.delete.confirm': 'Остаточно вилучити це обладнання?',
  'fleet.delete.yes': 'Вилучити',

  // --- Bulles d'aide (HelpHint) ---
  'help.label': 'Довідка',
  'help.overview.projects':
    "Проєкт наскрізно об'єднує відео, зображення й моделі навколо однієї мети — незалежно від кампаній збору.",
  'help.overview.fleet':
    'Парк перелічує дрони, роботів і обчислювачі. Кожна картка відокремлює обчислення й сенсори (те, що адаптує модель) від метаданих планера.',
  'help.overview.evaluatedModels':
    "mAP (mean Average Precision) вимірює якість моделі виявлення: що вище значення, то краще модель локалізує та класифікує об'єкти.",
  'help.data.videos':
    'Завантажуйте відео з дрона, потім розмічайте їх. Байти йдуть прямо до захищеного сховища, ніколи через посередника.',
  'help.data.images':
    'Витягуйте кадри з відео для розмітки рамками — основа навчального набору для виявлення.',
  'help.data.campaigns':
    "Кампанія об'єднує польотні сесії (виїзди в поле). Вона організовує збір даних, окремо від наскрізних проєктів.",
  'help.data.addToProject':
    'Прикріпіть вибране до наскрізного проєкту, щоб зібрати його разом з іншими медіа та моделями навколо однієї мети.',
  'help.model.import':
    'Імпортуйте власні ваги ONNX. Модель оцінюється на ваших даних перед будь-яким розгортанням. Щоб почати з наявної моделі, запозичте її з каталогу Model Zoo.',
  'help.model.registry':
    'Ваші моделі та їхні версії (верх Model Zoo). mAP (якість виявлення) дозволяє їх порівнювати; розгорнути можна лише готову й оцінену модель.',
  'help.model.catalog':
    'Попередньо навчені моделі (Yolo, ResNet…), готові до запозичення та оцінювання на ваших даних. Кожна картка показує надійність, права використання та ліцензію.',
  'help.model.process':
    'Повний шлях до моделі: визначити ціль проєкту (що виявляти, на яких даних, для якого обладнання), далі дані, базова модель, навчання, оцінювання й розгортання. Поступ зчитується з ваших реальних даних.',
  'help.members.roles':
    'Ролі — від Читача (лише перегляд) до Власника, через Анотатора, Редактора й Адміністратора. Кожна роль успадковує права попередніх.',
  'help.members.invite':
    'Запрошення надсилає одноразове посилання; людина приєднується до організації з обраною роллю. Очікуване запрошення можна відкликати.',
  'help.simulation.what':
    'Генеруйте синтетичні навчальні зображення (сцени, загрози, погода). Кожну партію переглядає людина, перш ніж вона зможе живити навчання.',
  'help.objective':
    'Ціль описує, що проєкт прагне виявляти і за яких умов. Вона виводить керований план, обчислений зі справжнього стану даних — ніколи фіксовану позначку часу.',

  // --- Керований тур (ADR-0031): елементи керування ---
  'tour.step': 'Крок',
  'tour.next': 'Далі',
  'tour.prev': 'Назад',
  'tour.skip': 'Пропустити',
  'tour.finish': 'Готово',

  // --- Тур «overview»: чотири розділи + довідка ---
  'tour.overview.overview.title': 'Overview — ваша панель',
  'tour.overview.overview.text':
    'Відправна точка: останні відео, оцінені моделі та стан парку — з першого погляду.',
  'tour.overview.data.title': 'Data — ваші дані',
  'tour.overview.data.text':
    'Завантажуйте відео з дрона та витягуйте кадри для розмітки. Байти йдуть напряму до захищеного сховища, ніколи через посередника.',
  'tour.overview.model.title': 'Model — ваші моделі',
  'tour.overview.model.text':
    'Імпортуйте, беріть із бібліотеки або навчайте моделі виявлення, потім стежте за їхніми метриками оцінювання.',
  'tour.overview.deploy.title': 'Deploy — ваш парк',
  'tour.overview.deploy.text':
    'Обліковуйте дрони, роботів і обчислювачі та складайте їхні специфікації деталей. Найкорисніше для керівника парку — але завжди доступне.',
  'tour.overview.account.title': 'Ваш обліковий запис і налаштування',
  'tour.overview.account.text':
    'Профіль, тема, вихід — і вибір вашого профілю використання, який можна змінити будь-коли. Ви також можете повторити цей тур.',

  // --- Персони (ADR-0031): вікно першого входу + налаштування профілю ---
  'persona.modal.title': 'Як ви використовуєте платформу?',
  'persona.modal.subtitle':
    'Ваш профіль підлаштовує домашню вкладку та запропоновані тури. Нічого не приховано, і ви можете змінити це будь-коли у профілі. Це налаштування відображення — не роль і не дозвіл.',
  'persona.modal.confirm': 'Продовжити',
  'persona.modal.skip': 'Пропустити — залишитися Універсалом',
  'persona.GENERALIST.label': 'Універсал',
  'persona.GENERALIST.desc': 'Ознайомлення та різнобічне використання платформи.',
  'persona.GENERALIST.lands': 'Відкриває: Overview',
  'persona.COLLECTOR.label': 'Польовий збирач',
  'persona.COLLECTOR.desc': 'Я завантажую й упорядковую свої польотні відео та зображення.',
  'persona.COLLECTOR.lands': 'Відкриває: Data',
  'persona.AI_ENGINEER.label': 'Інженер ШІ',
  'persona.AI_ENGINEER.desc': 'Я навчаю, імпортую та оцінюю моделі виявлення.',
  'persona.AI_ENGINEER.lands': 'Відкриває: Model',
  'persona.FLEET_MANAGER.label': 'Керівник парку',
  'persona.FLEET_MANAGER.desc': 'Я керую польовим обладнанням та його специфікаціями деталей.',
  'persona.FLEET_MANAGER.lands': 'Відкриває: Deploy',
  'persona.OPERATOR.label': 'Польовий оператор',
  'persona.OPERATOR.desc': 'Я захищаю зону: стежу за загрозами та своїми дронами-захисниками.',
  'persona.OPERATOR.lands': 'Відкриває: Ops',

  // --- Операційний вигляд counter-UAS (ADR-0040) ---
  'ops.title': 'Оперативна обстановка',
  'ops.subtitle':
    'Виявлені загрози та засоби захисту над зоною, що обороняється, майже в реальному часі.',
  'ops.zone.label': 'Зона оборони',
  'ops.zone.loading': 'Завантаження зон…',
  'ops.zone.none': 'Немає операційної зони',
  'ops.zone.empty': 'Зону ще не визначено. Адміністратор створює її через API операцій.',
  'ops.picture.loading': 'Завантаження обстановки…',
  'ops.picture.error': 'Не вдалося завантажити обстановку.',
  'ops.live': 'Наживо',
  'ops.updated': 'Оновлено',
  'ops.basemap.missing':
    'Картографічну основу не налаштовано: позиції показано на нейтральному (суверенному) тлі.',
  'ops.threats.title': 'Загрози',
  'ops.threats.none': 'Немає активних загроз',
  'ops.defenders.title': 'Захисники',
  'ops.defenders.none': 'Немає розміщених захисників',
  'ops.legend.title': 'Легенда',
  'ops.field.speed': 'Швидкість',
  'ops.field.heading': 'Курс',
  'ops.field.altitude': 'Висота',
  'ops.field.size': 'Розмір',
  'ops.field.battery': 'Батарея',
  'ops.field.lastSeen': 'Помічено',
  'ops.level.LOW': 'Низький',
  'ops.level.MEDIUM': 'Середній',
  'ops.level.HIGH': 'Високий',
  'ops.level.CRITICAL': 'Критичний',
  'ops.class.UNKNOWN': 'Невідомо',
  'ops.class.MULTIROTOR': 'Мультиротор',
  'ops.class.FIXED_WING': 'Літакового типу',
  'ops.class.HELICOPTER': 'Гелікоптер',
  'ops.class.OTHER': 'Інше',
  'ops.status.AVAILABLE': 'Доступний',
  'ops.status.ENGAGED': 'У дії',
  'ops.status.RETURNING': 'Повертається',
  'ops.status.CHARGING': 'Заряджання',
  'ops.status.OFFLINE': 'Офлайн',
  'ops.manage.add': 'Приєднати',
  'ops.manage.assetLabel': 'Засіб для приєднання',
  'ops.manage.noCandidates': 'Немає доступних дронів/UGV для приєднання.',
  'ops.manage.status': 'Стан захисника',
  'ops.manage.reposition': 'Перемістити',
  'ops.manage.remove': 'Вилучити',
  'ops.manage.placing': 'Клацніть на карті, щоб розмістити',
  'ops.manage.cancelPlacing': 'Скасувати',
  'ops.manage.error': 'Дію не виконано.',
  'ops.zone.new': 'Нова зона',
  'ops.zone.create.title': 'Створити зону оборони',
  'ops.zone.create.name': 'Назва зони',
  'ops.zone.create.lat': 'Широта центру',
  'ops.zone.create.lon': 'Довгота центру',
  'ops.zone.create.radius': 'Радіус оборони (м)',
  'ops.zone.create.submit': 'Створити зону',
  'ops.zone.create.cancel': 'Скасувати',
  'ops.sim.label': 'Симульовані загрози',
  'ops.sim.on': 'Увімкнено',
  'ops.sim.off': 'Вимкнено',

  // --- Тури розділів (ADR-0031, інкремент 2): повтор + вміст по сторінках ---
  'tour.replay': 'Повторити тур',
  'tour.data.videos.title': 'Ваші відео',
  'tour.data.videos.text':
    'Завантажуйте відео з дрона й стежте за їхнім статусом. З готового відео можна розмічати та витягувати кадри.',
  'tour.data.images.title': 'Витягнуті кадри',
  'tour.data.images.text':
    'Стоп-кадри з відео збираються тут: матеріал для розмітки рамками для навчання.',
  'tour.model.import.title': 'Імпорт або запозичення моделі',
  'tour.model.import.text':
    'Почніть із моделі з кураторської бібліотеки або імпортуйте власні ваги ONNX для оцінювання на ваших даних.',
  'tour.model.registry.title': 'Реєстр моделей',
  'tour.model.registry.text':
    'Ваші моделі та їхні версії з метриками оцінювання (mAP) — щоб порівняти й обрати, яку розгортати.',
  'tour.deploy.compute.title': 'Бортові обчислення',
  'tour.deploy.compute.text':
    'Обчислювач і сенсори обладнання: визначають, яка модель може на ньому працювати і як її адаптувати.',
  'tour.deploy.hardware.title': 'Hardware — каталог і специфікація',
  'tour.deploy.hardware.text':
    'Переглядайте організований каталог деталей і складайте специфікацію кожного пристрою парку.',
  // --- Hardware : catalogue de pièces + nomenclature (ADR-0030, incrément 1c) ---
  // --- Packaging de modèle : déploiement edge (ADR-0034) ---
  'deploy.packaging.title': 'Пакування',
  'deploy.packaging.lead':
    'Запакуйте перевірену модель для цільового середовища пристрою (ONNX, TFLite, TensorRT) з квантуванням, підібраним під його обчислювальний бюджет.',
  'deploy.packaging.dormantNote':
    'Створити пакунок можна; побудова неактивна, доки не ввімкнено вузол конвертації.',
  'deploy.packaging.dormantTitle': 'Побудова недоступна',
  'deploy.packaging.dormantBody':
    'Пакування неактивне: конвертація/квантування виконуватиметься на зовнішньому вузлі, який увімкнуть пізніше.',
  'help.deploy.packaging':
    'Пакунок фіксує вибір пакування (середовище, квантування, розмір входу) перевіреної моделі для апаратної цілі. Саме обчислювальна оболонка цілі — а не її планер — рекомендує формат і квантування.',
  'deploy.packaging.field.model': 'Перевірена модель',
  'deploy.packaging.field.modelPlaceholder': 'Оберіть модель…',
  'deploy.packaging.field.target': 'Апаратна ціль',
  'deploy.packaging.field.targetNone': 'Без цілі (загальна)',
  'deploy.packaging.field.runtime': 'Середовище виконання',
  'deploy.packaging.field.quantization': 'Квантування',
  'deploy.packaging.field.inputSize': 'Розмір входу',
  'deploy.packaging.noReadyModel': 'Поки немає перевірених (READY) моделей для пакування.',
  'deploy.packaging.computeEnvelope': 'Обчислювальна оболонка цілі',
  'deploy.packaging.computeEmpty': 'Обчислювальну оболонку не вказано',
  'deploy.packaging.recommendation': 'Рекомендовано',
  'deploy.packaging.create': 'Створити пакунок',
  'deploy.packaging.createError': 'Не вдалося створити.',
  'deploy.packaging.buildError': 'Не вдалося запустити.',
  'deploy.packaging.downloadError': 'Не вдалося завантажити.',
  'deploy.packaging.packages': 'Пакунки',
  'deploy.packaging.empty': 'Поки немає пакунків.',
  'deploy.packaging.build': 'Побудувати',
  'deploy.packaging.download': 'Завантажити бінарник',
  'deploy.packaging.delete': 'Видалити',
  'deploy.packaging.runtime.onnx': 'ONNX',
  'deploy.packaging.runtime.tflite': 'TFLite',
  'deploy.packaging.runtime.tensorrt': 'TensorRT',
  'deploy.packaging.quant.none': 'Немає (FP32)',
  'deploy.packaging.quant.fp16': 'FP16',
  'deploy.packaging.quant.int8': 'INT8',
  'deploy.packaging.status.draft': 'Чернетка',
  'deploy.packaging.status.queued': 'У черзі',
  'deploy.packaging.status.building': 'Побудова',
  'deploy.packaging.status.ready': 'Готово',
  'deploy.packaging.status.failed': 'Помилка',
  'deploy.hardwareLabel': 'Hardware',
  'deploy.hardwareText':
    'Бортове обладнання: складіть специфікацію деталей кожного пристрою з організованого каталогу деталей.',
  'help.deploy.hardware':
    'Каталог містить еталонні FPV-деталі (рами, мотори, ESC, камери…). Специфікація перелічує деталі конкретного пристрою, кожна з яких посилається на офіційну позицію каталогу.',
  'hw.tab.catalog': 'Каталог',
  'hw.tab.build': 'Специфікація',
  'hw.catalog.searchLabel': 'Пошук деталі',
  'hw.catalog.searchPlaceholder': 'бренд, модель…',
  'hw.catalog.all': 'Усі',
  'hw.catalog.curated':
    'Глобальний організований каталог: доступний для перегляду всім; додавання та застарівання позицій — лише для ролі SUPERADMIN. Без дублікатів (унікальна ідентичність категорія·бренд·модель·варіант).',
  'hw.catalog.empty': 'Немає позицій за цим фільтром.',
  'hw.photos.title': 'Фото збірки',
  'hw.photos.add': 'Додати фото',
  'hw.photos.uploading': 'Завантаження…',
  'hw.photos.hint':
    'З вашого браузера — JPEG, PNG або WebP, максимум 8 МБ. Байти не проходять через API.',
  'hw.photos.remove': 'Прибрати',
  'hw.photos.badType': 'Формат не підтримується (JPEG, PNG або WebP).',
  'hw.photos.tooBig': 'Фото завелике (максимум 8 МБ).',
  'hw.photos.uploadFailed': 'Помилка завантаження.',
  'hw.media.edit': 'Змінити зображення',
  'hw.media.add': 'Додати зображення',
  'hw.media.title': 'Ілюстрація деталі',
  'hw.media.close': 'Закрити',
  'hw.media.importLabel': 'Імпорт з URL виробника',
  'hw.media.importPlaceholder': 'https://виробник.com/…/продукт.jpg',
  'hw.media.import': 'Імпортувати',
  'hw.media.or': 'або',
  'hw.media.upload': 'Завантажити файл',
  'hw.media.remove': 'Прибрати зображення',
  'hw.media.hint': 'Лише дозволені хости виробників. JPEG/PNG/WebP, максимум 5 МБ.',
  'hw.media.working': 'Обробка…',
  'hw.media.needUrl': 'Вставте URL виробника.',
  'hw.media.badType': 'Формат не підтримується (JPEG, PNG або WebP).',
  'hw.media.tooBig': 'Зображення завелике (максимум 5 МБ).',
  'hw.media.uploadFailed': 'Помилка завантаження.',
  'hw.status.active': 'Активна',
  'hw.status.deprecated': 'Застаріла',
  'hw.cat.FRAME': 'Рама',
  'hw.cat.MOTOR': 'Мотори',
  'hw.cat.ESC': 'ESC',
  'hw.cat.FC': 'Політний контролер',
  'hw.cat.CAMERA': 'Камери',
  'hw.cat.VTX': 'Відеопередавач',
  'hw.cat.RX': 'Приймач',
  'hw.cat.BATTERY': 'Акумулятор',
  'hw.cat.PROP': 'Пропелери',
  'hw.cat.ANTENNA': 'Антени',
  'hw.cat.GPS': 'GPS',
  'hw.cat.OTHER': 'Інше',
  'hw.build.assetLabel': 'Пристрій',
  'hw.build.addPart': 'Додати деталь',
  'hw.build.save': 'Зберегти',
  'hw.build.saved': 'Специфікацію збережено',
  'hw.build.saveError': 'Не вдалося зберегти.',
  'hw.build.empty': 'Немає деталей. «Додати деталь», щоб скласти специфікацію.',
  'hw.build.note':
    'Кожен рядок посилається на офіційну позицію каталогу. Тюнінговані варіанти організації (прив’язані до офіційної) з’являться в наступному інкременті.',
  'hw.build.summary': 'Підсумок',
  'hw.build.lines': 'Рядки',
  'hw.build.totalQty': 'Деталі (загальна к-сть)',
  'hw.build.coverage': 'Покриття за категоріями',
  'hw.build.col.slot': 'Місце',
  'hw.build.col.part': 'Деталь',
  'hw.build.col.qty': 'К-сть',
  'hw.build.qtyMinus': 'Зменшити кількість',
  'hw.build.qtyPlus': 'Збільшити кількість',
  'hw.build.remove': 'Вилучити рядок',
  'hw.build.pickHeading': 'Додати деталь',
  'hw.build.pickAdd': 'Додати',
  'hw.build.noAsset.title': 'У парку немає обладнання',
  'hw.build.noAsset.body': 'Спершу додайте пристрій до парку, щоб скласти його специфікацію.',
  'hw.build.noAsset.link': 'Перейти до парку',
  // --- Variantes tunées de nomenclature (ADR-0030 §3, incrément 1d) ---
  'hw.build.variantLabel': 'Варіант',
  'hw.build.official': '— (офіційна)',
  'hw.build.newVariant': '+ Створити варіант…',
  'hw.build.tuned': 'тюнінг',
  'hw.build.tunedCount': 'Тюнінговані варіанти',
  'hw.variant.heading': 'Створити тюнінгований варіант',
  'hw.variant.for': 'Похідний від',
  'hw.variant.labelField': 'Назва варіанта',
  'hw.variant.labelPlaceholder': 'напр. Перемотка 1750KV',
  'hw.variant.noteField': 'Примітка (необов’язково)',
  'hw.variant.overrides': 'Перевизначення специфікацій (необов’язково)',
  'hw.variant.overrideKey': 'ключ',
  'hw.variant.overrideValue': 'значення',
  'hw.variant.addOverride': 'Додати перевизначення',
  'hw.variant.removeOverride': 'Вилучити перевизначення',
  'hw.variant.create': 'Створити',
  'hw.variant.creating': 'Створення…',
  'hw.variant.cancel': 'Скасувати',
  'hw.variant.createError': 'Не вдалося створити.',

  'search.open': 'Розширений пошук',
  'search.back': '← Відео',
  'search.title': 'Розширений пошук',
  'search.subtitle':
    'Фільтруйте відео за текстом, апаратом, пілотом, датами, анотаціями та мітками.',
  'search.query': 'Повнотекстовий пошук',
  'search.queryPlaceholder': 'напр. лінія ВН опора',
  'search.status': 'Статус',
  'search.any': 'Усі',
  'search.asset': 'Апарат',
  'search.anyAsset': 'Усі апарати',
  'search.pilot': 'Пілот',
  'search.flownFrom': 'Виліт від',
  'search.flownTo': 'Виліт до',
  'search.annotations': 'Анотації',
  'search.withAnnotations': 'З анотаціями',
  'search.withoutAnnotations': 'Без анотацій',
  'search.sortBy': 'Сортувати за',
  'search.sort.createdAt': 'Дата додавання',
  'search.sort.flownAt': 'Дата зйомки',
  'search.sort.title': 'Назва',
  'search.sort.duration': 'Тривалість',
  'search.order': 'Порядок',
  'search.order.desc': 'Спадання',
  'search.order.asc': 'Зростання',
  'search.labels': 'Мітки',
  'search.submit': 'Шукати',
  'search.reset': 'Скинути',
  'search.errorTitle': 'Помилка пошуку',
  'search.noResults': 'Жодне відео не відповідає критеріям.',
  'search.results': 'результат(ів)',
  'search.loadMore': 'Завантажити ще',
  'search.loading': 'Завантаження…',
  'search.geo.title': 'Географічна область',
  'search.geo.canvasLabel': 'Карта вибору області; намалюйте прямокутник для фільтрування.',
  'search.geo.hint': 'Намалюйте прямокутник на карті, щоб обмежити областю.',
  'search.geo.emptyHint':
    'Поки немає геоприв’язаних треків — ви все одно можете намалювати область.',
  'search.geo.clear': 'Очистити область',
};
